var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M61.2812 1.75H1V44.25H61.2812V1.75Z","stroke":"#D25D18","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M61.2812 1.75L31.1406 23L1 1.75","stroke":"#D25D18","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M36.8319 18.9979L52.4164 33.625","stroke":"#D25D18","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M9.10254 33.625L25.4494 18.9979","stroke":"#D25D18","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Mail.defaultProps = {"width":"63","height":"46","viewBox":"0 0 63 46","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
